// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1e9761b1","455":"57e6af9a","977":"998c516b"}[chunkId] + ".chunk.js";
};